import { graphql } from "react-relay";

export const TREE_NODE_FRAGMENT = graphql`
	fragment createIhkCertificateRewardBundleButton_TreeNodeFragment on TreeNode {
		id
		typeDefinition {
			... on ELearningContentTypeDefinition {
				rewards {
					id
					kind
				}
			}
		}
	}
`;

export const ADD_IHK_CERTIFICATE_REWARD_BUNDLE_MUTATION = graphql`
	mutation createIhkCertificateRewardBundleButton_AddIHKCertificateRewardBundleMutation(
		$input: AddIHKCertificateBundleRewardInput!
	) {
		Admin {
			Tree {
				addIHKCertificateBundleReward(input: $input) {
					content {
						...rewardEditor_TreeNodeFragment
					}
				}
			}
		}
	}
`;
